import { create } from "zustand";
import { Product } from "./product.model";
import { createJSONStorage, persist } from "zustand/middleware";
import { Sustainability } from "./sustainability.model";
import { ProductHistory } from "./product-history.model";
import { Marketplace, Partner } from "./partner.model";
import type { BrandRelations } from "../brand-relations/brand-relations.model";

interface WalletState {
  products: Product[];
  marketplaces: Marketplace[];
  partners: Partner[];
  brandRelations?: BrandRelations;
  sustainability?: Sustainability;
  history?: ProductHistory[];
  wasPopupSeen: boolean;
  loading: boolean;
  isCarouselView: boolean;
}

interface WalletActions {
  setProducts: (products: Product[]) => void;
  setMarketplaces: (marketplaces: Marketplace[]) => void;
  setPartners: (partners: Partner[]) => void;
  setBrandRelations: (brandRelations?: BrandRelations) => void;
  setSustainability: (sustainability: Sustainability) => void;
  setHistory: (history: ProductHistory[]) => void;
  setLoading: (loading: boolean) => void;
  setWasPopupSeen: (wasPopupSeen: boolean) => void;
  reset: () => void;
  setIsCarouselView: (isCarouselView: boolean) => void;
}

export const WalletStore = create<WalletState & WalletActions>()(
  persist(
    (set) => ({
      products: [],
      marketplaces: [],
      partners: [],
      brandRelations: undefined,
      sustainability: undefined,
      history: [],
      wasPopupSeen: false,
      loading: false,
      isCarouselView: true,
      setProducts: products => set({ products }),
      setMarketplaces: marketplaces => set({ marketplaces }),
      setPartners: partners => set({ partners }),
      setBrandRelations: brandRelations => set({ brandRelations }),
      setSustainability: sustainability => set({ sustainability }),
      setHistory: history => set({ history }),
      setLoading: loading => set({ loading }),
      setWasPopupSeen: wasPopupSeen => set({ wasPopupSeen }),
      setIsCarouselView: isCarouselView => set({ isCarouselView }),
      reset: () => set({
        products: [],
        brandRelations: undefined,
        sustainability: undefined,
        loading: false,
      }),
    }),
    {
      name: "_wallet_wallet_storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
)